export default function arrayifyWithKey(obj) {
  let newArray = []
  const objKeys = Object.keys(obj)
  objKeys.forEach( (key) => {
    newArray.push({
      ...obj[key],
      key,
    })  
  })
  return newArray
}


// WEBPACK FOOTER //
// ./src/helpers/arrayifyWithKey.js